<!-- 医疗左侧导航链接 -->
<template>
  <div class="aside">
    <h3>
      <img src="@/assets/submenu02.png" />
    </h3>
    <el-menu :default-active="activeindex" class="el-menu-vertical-demo" active-text-color="#f00" :router="true">
      <el-menu-item v-for="(item, index) in menu" :key="index" :index="item.path" @click="setactive(item.path)">
        <span slot="title">{{ item.tit }}</span>
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      menu: [
        { path: '/chinatele/case01', tit: '电子渠道解决方案' },
        { path: '/chinatele/case02', tit: '资金归集管理系统' },
        { path: '/chinatele/case03', tit: '统一支付平台' },
        { path: '/chinatele/case04', tit: '政企协同管控平台' },
        { path: '/chinatele/case05', tit: '精准营销系统' },
        { path: '/chinatele/case06', tit: '智慧运营分析系统' },
        { path: '/chinatele/case07', tit: '互联网轻营销工具' },
        { path: '/chinatele/case08', tit: '互联网分销系统' },
        { path: '/chinatele/case09', tit: 'IPv6 升级改造解决方案' }
      ],

      activeindex: '/chinatele/case01'
    }
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    setactive(index) {
      this.activeindex = index
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
//@import url(); 引入公共css类
.aside {
  width: 239px;
  float: left;
  .el-menu {
    border: none;
    background: #f7f7f7;
    .el-menu-item {
      font-size: 16px;
    }
    .el-menu-item.is-active {
      font-size: 16px;
      font-weight: bold;
    }
  }
}
</style>
